/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

angular
    .module('app.constants')
    .constant('REDIRECT_TO_404', true)
    .constant('INHOUSE_CATEGORY', 2)
    .constant('AUTOGENERATED_CATEGORY', 3)
    .constant('SELECTIVITY_NO_CATEGORY', 'SELECTIVITY_NO_CATEGORY');



// WEBPACK FOOTER //
// ./scripts/shared/constants/constants.js